import { gql } from '@apollo/client';
import { type DocumentNode } from 'graphql';

export const GET_STATUS_PAGE_BY_COMMUNITY_ID: DocumentNode = gql`
  query communityRemovalStatus($communityId: Int!, $isAdvanced: Boolean) {
    communityRemovalStatus(communityId: $communityId, isAdvanced: $isAdvanced) {
      id
      communityId
      communityName
      communityUrl
      removeDate
      mediaFilesStatus
      userRemovalStatus
      communityDataStatus
      communityMetadataStatus
      report
      error
      overallStatus
    }
  }
`;
